import React, { useEffect, useState } from "react";
import { Button, Dropdown, Form, InputGroup } from 'react-bootstrap'
import { Box, Checkbox, ListItemText, MenuItem, Select, Typography } from '@mui/material';
import Modal from 'react-bootstrap/Modal'
import axios from "axios";
import CheckIcon from '@mui/icons-material/Check';
import NavBar from "../../structure/NavBar";
import { NavBarTop } from "../../structure/NavBarTop";
import { useDispatch, useSelector } from "react-redux";
import { updateLoading } from "../../../redux/features/common/commonSlice";
import urls from "../../constants/apiurl";
import ApiCaller from "../../constants/ApiCaller";
import { showDangerToast, showToast } from "../../constants/toaster";
import VideoCard from "./VideoCard";
import CapsuleProfile from "./CapsuleProfile";
import { s3 } from "../../constants/awsConfig";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import ReplyIcon from '@mui/icons-material/Reply'
import TextField from '@mui/material/TextField'; // Add this if not present


const UploadVideo = props => {
  const router = useNavigate()
  const navigate = useNavigate()
  const [botLabel, setBotLabel] = useState('Select Bot Account')
  const [uploadFileProgressBar, setUploadFileProgressBar] = useState(-1)
  const [uploadFileSingleProgressBar, setUploadFileSingleProgressBar] = useState(0)
  const [selectedBotValues, setSelectedBotValues] = useState([]);
  const [selectedLanguageValues, setSelectedLanguageValues] = useState([]);
  const [selectedCategoryValues, setSelectedCategoryValues] = useState([]);
  const [renderedVideos, setRenderedVideos] = useState([]);
  const batchSize = 10; // Load 10 videos at a time
  const [progress, setProgress] = useState(0); // Track progress
  const userData = useSelector(state => state?.userData)
  const dispatch = useDispatch()
  const [showUploadVideoModal, setShowUploadVideoModal] = useState(true)
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [countryDropdownText, setCountryDropdownText] = useState({
    id: '',
    lable: 'Select Country'
  })
  const [countryCodeList, setCountryCodeList] = useState([
    {
      id: '',
      name: 'Select Country'
    }
  ])

  const [botUserDataList, setBotUserDataList] = useState([])
  const [botUserDataListComplete, setBotUserDataListComplete] = useState([])

  const [languageFilterData, setLanguageFilterData] = useState([])
  const [categoryFilterData, setCategoryFilterData] = useState([])

  const [uploadTypeDropdownText, setUploadTypeDropdownText] = useState({
    id: '',
    lable: 'Select Type'
  })
  const [uploadTypeList, setUploadTypeList] = useState([
    {
      id: '',
      name: 'Select Type'
    },
    {
      id: 'RANDOM',
      name: 'Random'
    },
    {
      id: 'SELECTED_BOTS_ONLY',
      name: 'Selected Bots Only'
    }
    // {
    //   id: 'VIDEO_WITH_BOT',
    //   name: 'Assigned Bots'
    // }
  ])

  const [failedVideos, setFailedVideos] = useState([]);

  const handleChange = (event, type) => {
    if (type === 0) {
      setSelectedBotValues(event.target.value);
    } else if (type === 1) {
      setSelectedLanguageValues(event.target.value);
    } else if (type === 2) {
      setSelectedCategoryValues(event.target.value);
    }
  };

  const getLanguageFilterData = async () => {
    try {
      dispatch(updateLoading(true));
      let path = urls.languageListKeyValuePair + "?keyword=";
      let res = await ApiCaller.get({}, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status == 200) {
        dispatch(updateLoading(false));
        let tempArray = []
        response?.data?.map((data) => {
          tempArray.push({
            label: data?.value,
            value: data?.key
          })
        })
        setLanguageFilterData(tempArray)
      } else {
        dispatch(updateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(updateLoading(false));
      console.error(error);
      showDangerToast(error.message);
    }
  }
  const getCategoryFilterData = async () => {
    try {
      dispatch(updateLoading(true));
      let path = urls.tagInterestListKeyValuePair + "?keyword=";
      let res = await ApiCaller.get({}, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status == 200) {
        dispatch(updateLoading(false));
        let tempArray = []
        response?.data?.map((data) => {
          tempArray.push({
            label: data?.value,
            value: data?.key
          })
        })
        setCategoryFilterData(tempArray)
      } else {
        dispatch(updateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(updateLoading(false));
      console.error(error);
      showDangerToast(error.message);
    }
  }


  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files); // Convert FileList to an array
    const validFiles = files.filter((file) => file.type === 'video/mp4');

    if (validFiles.length < files.length) {
      alert('Some files were not added as they are not .mp4');
    }

    const filesWithPreview = validFiles.map((file) => ({
      file,
      previewUrl: URL.createObjectURL(file),
      likes: 0,
      views: 0
    }));
    setShowUploadVideoModal(!showUploadVideoModal)
    setSelectedFiles((prevFiles) => [...prevFiles, ...filesWithPreview]);
  };

  const getVideoThumbnail = (file) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.src = URL.createObjectURL(file);
      video.crossOrigin = 'anonymous';
      video.muted = true;

      video.onloadeddata = () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth / 4; // Thumbnail width
        canvas.height = video.videoHeight / 4; // Thumbnail height
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toDataURL('image/png', (url) => {
          resolve(canvas.toDataURL('image/png')); // Return thumbnail as a data URL
        });
      };

      video.onerror = (err) => reject(err);
    });
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    getCountryCodeList()
    getLanguageFilterData()
    getCategoryFilterData()
  }, [])

  useEffect(() => {
    let index = 0;

    const loadVideos = () => {
      // Get next batch of videos
      const nextVideos = selectedFiles.slice(index, index + batchSize);
      setRenderedVideos((prev) => [...prev, ...nextVideos]);

      index += batchSize;
      // Update progress bar
      const progressPercentage = Math.min(
        (index / selectedFiles.length) * 100,
        100
      );
      dispatch(updateLoading(progressPercentage !== 100))
      setProgress(progressPercentage);
      // Continue loading until we reach the end of the list
      if (index < selectedFiles.length) {
        setTimeout(loadVideos, 5000); // Delay to throttle the process
      }
    };

    loadVideos();
  }, [selectedFiles]);

  const getCountryCodeList = async () => {
    try {
      dispatch(updateLoading(true))
      let path = urls.countryCodeList
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        let tempArray = []
        tempArray.push(...response?.data)
        setCountryCodeList(tempArray)
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }
  const getBotAccountKeyValuePair = async () => {
    try {
      dispatch(updateLoading(true))
      let path = urls.botAccountKeyValuePair + "?countryId=" + countryDropdownText?.id
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        let tempArray = []
        for (let i = 0; i < response?.data?.length; i++) {
          tempArray.push(response?.data?.[i]?.userName)
        }
        setBotUserDataList(tempArray)
        setBotUserDataListComplete(response?.data)
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const uploadFiles = async (files) => {
    if (!files || files.length === 0) return [];
    const totalFiles = files.length;
    let uploadedCount = 0; // Counter for uploaded files
    const uploadedUrls = []; // Array to store uploaded URLs
    setUploadFileProgressBar(0); // Initialize the progress bar

    const uploadPromises = files.map((contentUrl) => {
      const randomUUID = uuidv4();
      const timestamp = Date.now();
      const newFileName = timestamp + "." + contentUrl.file?.type?.split("/")[1];
      const params = {
        Bucket: 'supa-dev-bucket',
        Key: `video/${randomUUID}/${newFileName}`,
        Body: contentUrl.file,
        ContentType: contentUrl.file?.type,
      };

      return new Promise((resolve, reject) => {
        const upload = s3.upload(params);
        setUploadFileSingleProgressBar(0)
        // Track progress
        upload.on('httpUploadProgress', (progress) => {
          const percent = (progress.loaded / progress.total) * 100;
          setUploadFileSingleProgressBar(percent.toFixed(2))
          // Update individual file progress if needed
        });

        upload.promise()
          .then((data) => {
            const url = data.Location.replace(
              "https://supa-dev-bucket.s3.af-south-1.amazonaws.com/",
              "https://d2up68x544gew2.cloudfront.net/"
            );

            uploadedCount++;
            setUploadFileProgressBar(uploadedCount); // Update the progress bar
            uploadedUrls.push({ link: url, totalLikes: contentUrl?.likes, totalView: contentUrl?.views, languageIds: selectedLanguageValues, categoryIds: selectedCategoryValues }); // Add the URL to the list

            resolve(url);
          })
          .catch((error) => {
            console.error(`Error uploading ${contentUrl.file?.name}:`, error);
            reject(error);
          });
      });
    });

    try {
      // Wait for all files to be uploaded
      await Promise.all(uploadPromises);
      dispatch(updateLoading(false))
      return uploadedUrls; // Return the list of uploaded file URLs
    } catch (error) {
      console.error('Error uploading some files:', error);
      return []; // Return an empty array in case of errors
    }
  };

  // Retry upload for failed videos
  const handleRetryFailedVideos = async () => {
    try {
      dispatch(updateLoading(true));
      let tempBotAccoutsList = [];
      if (uploadTypeDropdownText?.id === 'SELECTED_BOTS_ONLY') {
        for (let i = 0; i < selectedBotValues?.length; i++) {
          for (let j = 0; j < botUserDataListComplete?.length; j++) {
            if (selectedBotValues?.[i] === botUserDataListComplete?.[j]?.userName) {
              tempBotAccoutsList.push(botUserDataListComplete?.[j]?.id);
              break;
            }
          }
        }
      }
      let postJson = {
        countryId: countryDropdownText?.id,
        uploadContentRangeType: uploadTypeDropdownText?.id,
        videoList: failedVideos,
        botIds: tempBotAccoutsList
      }
      let path = urls.botVideoUpload;
      let res = await ApiCaller.post(postJson, path, userData?.access_token);
      const response = await res.response.json();
      if (
        response.message === "some videos failed to upload. Please check  for details." &&
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {
        setFailedVideos(response.data);
        showDangerToast("Some videos failed to upload. Please check and retry.");
      } else if (response.status == 200) {
        setFailedVideos([]);
        showToast(response?.message);
        navigate('/video-upload-manager');
      } else {
        showDangerToast(response.message || "Retry failed.");
      }
      dispatch(updateLoading(false));
    } catch (error) {
      dispatch(updateLoading(false));
      showDangerToast(error.message || "Retry failed.");
    }
  };

  // Handler for editing failed video fields
  const handleFailedVideoChange = (idx, field, value) => {
    setFailedVideos(prev => prev.map((video, i) => i === idx ? { ...video, [field]: value } : video));
  };

  const confirmAndUploadVideo = async () => {
    try {
      if (!countryDropdownText?.id) {
        showDangerToast('Please select a country.');
        return;
      }
      if (!uploadTypeDropdownText?.id) {
        showDangerToast('Please select a type.');
        return;
      }
      setUploadFileProgressBar(-1)
      dispatch(updateLoading(true))
      const uploadedVideosListUrl = await uploadFiles(renderedVideos);
      let tempBotAccoutsList = [];
      if (uploadTypeDropdownText?.id === 'SELECTED_BOTS_ONLY') {
        for (let i = 0; i < selectedBotValues?.length; i++) {
          for (let j = 0; j < botUserDataListComplete?.length; j++) {
            if (selectedBotValues?.[i] === botUserDataListComplete?.[j]?.userName) {
              tempBotAccoutsList.push(botUserDataListComplete?.[j]?.id);
              break;
            }
          }
        }
      }
      let postJson = {
        countryId: countryDropdownText?.id,
        uploadContentRangeType: uploadTypeDropdownText?.id,
        videoList: uploadedVideosListUrl,
        botIds: tempBotAccoutsList
      }
      let path = urls.botVideoUpload
      let res = await ApiCaller.post(postJson, path, userData?.access_token)
      const response = await res.response.json()
      if (
        response.message === "some videos failed to upload. Please check  for details." &&
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {
        setFailedVideos(response.data);
        showDangerToast("Some videos failed to upload. Please check and retry.");
      } else if (response.status == 200) {
        setFailedVideos([]);
        showToast(response?.message)
        navigate('/video-upload-manager')
      } else {
        showDangerToast(response.message)
      }
      dispatch(updateLoading(false))
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>

        <div className='container-fluid mt--7'>
          <div className='row'>
            <div className='col-12 mb-3 text-left'>
              <a
                onClick={() => router("/video-upload-manager")}
                className='btn btn-sm btn-primary text-white'
                style={{ display: 'inline-flex', alignItems: 'center' }}
              >
                <ReplyIcon style={{ marginRight: 4 }} />
                Back
              </a>
            </div>
          </div>
          <div className='row'>
            {/* Hidden file input */}
            <input
              type="file"
              id="fileInput"
              multiple
              accept=".mp4"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
            <div className='col text-left'>
              <div className='card shadow'>
                <div className='card-header border-0'>
                  <div className='row align-items-center text-left'>
                    <div className='col'>
                      <h3 className='mb-0'>Selected Videos</h3>
                    </div>
                    <div className='col text-right'>
                      {failedVideos.length === 0 ? (
                        <a
                          className='btn btn-sm btn-primary text-white'
                          onClick={confirmAndUploadVideo}
                        >
                          <CheckIcon className="mr-2" />
                          Confirm
                        </a>
                      ) : (
                        <Button
                          className='btn btn-sm btn-primary text-white'
                          onClick={handleRetryFailedVideos}
                        >
                          <CheckIcon className="mr-2" />
                          Retry Upload
                        </Button>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-3'>
                      <Form.Group controlId='exampleForm.ControlInput1'>
                        <div style={{ display: 'grid' }}>
                          <Form.Label>Select Country*</Form.Label>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant='success'
                              style={{
                                backgroundColor: 'white',
                                color: 'black',
                                border: '1px solid #cad1d7',
                                boxShadow: 'none',
                                transform: 'none'
                              }}
                              id='dropdown-basic'
                            >
                              {countryDropdownText?.lable}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {countryCodeList?.map((item, i) => {
                                return (
                                  <>
                                    <Dropdown.Item
                                      eventKey={item?.id}
                                      onClick={() => {
                                        setCountryDropdownText({
                                          id: item?.id,
                                          lable: item?.name
                                        })
                                      }}
                                    >
                                      {item?.name}
                                    </Dropdown.Item>
                                  </>
                                )
                              })}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </Form.Group>

                    </div>
                    <div className='col-md-3'>
                      <Form.Group controlId='exampleForm.ControlInput1'>
                        <div style={{ display: 'grid' }}>
                          <Form.Label>Select Type*</Form.Label>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant='success'
                              style={{
                                backgroundColor: 'white',
                                color: 'black',
                                border: '1px solid #cad1d7',
                                boxShadow: 'none',
                                transform: 'none'
                              }}
                              id='dropdown-basic'
                            >
                              {uploadTypeDropdownText?.lable}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {uploadTypeList?.map((item, i) => {
                                return (
                                  <>
                                    <Dropdown.Item
                                      eventKey={item?.id}
                                      onClick={() => {
                                        setUploadTypeDropdownText({
                                          id: item?.id,
                                          lable: item?.name
                                        })
                                        if (item?.id && item?.id === 'SELECTED_BOTS_ONLY' && countryDropdownText?.id) {
                                          getBotAccountKeyValuePair()
                                        } else {
                                          setSelectedBotValues([])
                                        }
                                      }}
                                    >
                                      {item?.name}
                                    </Dropdown.Item>
                                  </>
                                )
                              })}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </Form.Group>
                    </div>
                    {uploadTypeDropdownText?.id === 'SELECTED_BOTS_ONLY' && countryDropdownText?.id ? <div className="col-md-3">
                      <Form.Group controlId='exampleForm.ControlInput1'>
                        <div style={{ display: 'grid' }}>
                          <Form.Label>Select Bot User</Form.Label>
                          <Select
                            multiple
                            value={selectedBotValues}
                            onChange={(e) => handleChange(e, 0)}
                            renderValue={(selected) => `${selected.length} Selected`} // Display count of selected items
                            label={botLabel}
                          >
                            {botUserDataList.map((option) => (
                              <MenuItem key={option} value={option}>
                                <Checkbox checked={selectedBotValues.indexOf(option) > -1} />
                                <ListItemText primary={option} />
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </Form.Group>
                    </div> : <></>}
                    <div className="col-md-3">
                      <Form.Group controlId='exampleForm.ControlInput1'>
                        <div style={{ display: 'grid' }}>
                          <Form.Label>Select Language</Form.Label>
                          <Select
                            multiple
                            value={selectedLanguageValues}
                            onChange={(e) => handleChange(e, 1)}
                            renderValue={(selected) => `${selected.length} Selected`} // Display count of selected items
                            label={botLabel}
                          >
                            {languageFilterData.map((option) => (
                              <MenuItem key={option?.label} value={option?.value}>
                                <Checkbox checked={selectedLanguageValues.indexOf(option?.value) > -1} />
                                <ListItemText primary={option?.label} />
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-md-3">
                      <Form.Group controlId='exampleForm.ControlInput1'>
                        <div style={{ display: 'grid' }}>
                          <Form.Label>Select Category</Form.Label>
                          <Select
                            multiple
                            value={selectedCategoryValues}
                            onChange={(e) => handleChange(e, 2)}
                            renderValue={(selected) => `${selected.length} Selected`} // Display count of selected items
                            label={botLabel}
                          >
                            {categoryFilterData.map((option) => (
                              <MenuItem key={option?.value} value={option?.label}>
                                <Checkbox checked={selectedCategoryValues.indexOf(option?.label) > -1} />
                                <ListItemText primary={option?.value} />
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </Form.Group>
                    </div>
                  </div>
                  {/* <div className="row">
                    {selectedBotValues?.length > 0 ? < >
                      {
                        selectedBotValues?.map((data, index) => {
                          return (<div className="col-md-2 mt-2">
                            <CapsuleProfile profilePic={'w'} username={data} /></div>)
                        })

                      }</> : <></>}
                  </div> */}

                  {/* Progress bar */}
                  {progress && progress > 0 && progress < 100 ? <div style={{ marginBottom: '20px', width: '100%' }}>
                    <div
                      style={{
                        height: '10px',
                        backgroundColor: '#ddd',
                        borderRadius: '5px',
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          height: '100%',
                          width: `${progress}%`,
                          backgroundColor: '#4caf50',
                          transition: 'width 0.2s ease',
                        }}
                      ></div>
                    </div>
                    <div style={{ textAlign: 'center', marginTop: '5px' }}>
                      {Math.round(progress)}% Loaded
                    </div>
                  </div> : <></>}
                  {/* Progress bar */}
                  {uploadFileProgressBar !== -1 ? <div style={{ marginBottom: '20px', width: '100%' }}>
                    <div
                      style={{
                        position: 'relative',
                        height: '10px',
                        backgroundColor: '#ddd',
                        borderRadius: '5px',
                        overflow: 'hidden',
                      }}
                    >
                      {/* Progress bar */}
                      <div
                        style={{
                          height: '100%',
                          width: `${uploadFileSingleProgressBar}%`,
                          backgroundColor: '#4caf50',
                          transition: 'width 0.2s ease',
                        }}
                      ></div>

                      {/* Start and End Percentages */}
                      <div
                        style={{
                          position: 'absolute',
                          top: '-20px', // Adjust position as needed
                          left: '0',
                          color: '#000',
                          fontSize: '12px',
                        }}
                      >
                        {uploadFileSingleProgressBar}%
                      </div>
                      <div
                        style={{
                          position: 'absolute',
                          top: '-20px', // Adjust position as needed
                          right: '0',
                          color: '#000',
                          fontSize: '12px',
                        }}
                      >
                        100%
                      </div>
                    </div>
                    <div style={{ textAlign: 'center', marginTop: '5px' }}>
                      {uploadFileProgressBar}/{selectedFiles?.length}
                    </div>

                  </div> : <></>}

                </div>
                {/* Show video cards for upload or failed videos */}
                {failedVideos.length > 0 ? (
                  <div className="row">
                    {failedVideos.map((data, index) => (
                      <div className="col-md-3" key={index}>
                        <VideoCard
                          index={index}
                          setRenderedVideos={videos => setFailedVideos(videos)} // For editing failed videos
                          likes={data?.totalLikes}
                          views={data?.totalView}
                          videoSrc={data.link || data.previewUrl}
                          editable={true}
                          errorMsg={data.failureMessage}
                          onFieldChange={(field, value) => handleFailedVideoChange(index, field, value)}
                        />
                      </div>
                    ))}
                  </div>
                ) : renderedVideos.length > 0 && (
                  <div className="row">
                    {renderedVideos.map((data, index) => (
                      <div className="col-md-3" key={index}>
                        <VideoCard
                          index={index}
                          setRenderedVideos={setRenderedVideos}
                          likes={data?.likes}
                          views={data?.views}
                          videoSrc={data.previewUrl}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {/* Remove failed videos table UI */}
              </div>
            </div>
          </div>
          {/* <Footer /> */}
        </div>
        <Modal
          backdrop="static" // Disable closing by clicking outside
          keyboard={false}  // Disable closing by pressing the escape key
          show={showUploadVideoModal}
          onHide={() => setShowUploadVideoModal(!showUploadVideoModal)}
          size='xl'
          aria-labelledby='contained-modal-title-vcenter'
          centered
        >
          <Modal.Header>
            <Modal.Title id='contained-modal-title-vcenter'>
              Upload Content
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: 200,
                border: '2px dashed #ccc',
                borderRadius: 2,
                backgroundColor: '#f9f9f9',
              }}
            >
              <Box
                component="img"
                src="https://ssl.gstatic.com/docs/picker/images/upload_background.png"
                alt="Cloud Icon"
                sx={{ width: 80, height: 80, mb: 2 }}
              />
              <Typography variant="body1" sx={{ mb: 2 }}>
                Drag a file here or
              </Typography>
              <Button variant="contained" color="primary" onClick={() => document.getElementById('fileInput').click()}>
                Browse
              </Button>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='outlined' color='secondary' onClick={() => {
              setShowUploadVideoModal(false);
              navigate(-1);
            }}>
              Back
            </Button>
          </Modal.Footer>
        </Modal >
      </div>
    </>
  );
};

export default UploadVideo;
